"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const deep_equal_1 = require("deep-equal");
class ValueObjectBase {
    constructor(valueObjectData) {
        if (valueObjectData) {
            for (let key in valueObjectData) {
                this[key] = valueObjectData[key];
            }
        }
    }
    /**
     * Compares this value object to another in terms of equality
     */
    equals(other) {
        return deep_equal_1.default(this, other);
    }
    /**
     * Clones the attributes of this object into a new instance of the value object
     */
    clone() {
        throw new Error('Clone method is not implemennted');
    }
}
exports.ValueObjectBase = ValueObjectBase;
//# sourceMappingURL=ValueObjectBase.js.map